import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import locationImage from './images/location.png';
import { blogPosts } from './blog/posts';
import './Home.css';
import FlagText from './components/FlagText';
import CountryInputHome from './components/CountryInputHome';

function Home() {
  const [isSpinning, setIsSpinning] = useState(false);
  const [location, setLocation] = useState('');
  const [showPopup, setShowPopup] = useState(true);
  const navigate = useNavigate();

  // Sort blog posts by date, newest first
  const sortedPosts = [...blogPosts].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  const latestPost = sortedPosts[0];

  const handleClick = () => {
    if (!location) {
      alert('Please enter a postcode.');
      return;
    }
    setIsSpinning(true);
    setTimeout(() => {
      navigate(`/courts?postcode=${location}`);
    }, 2000);
  };

  const handleLocationClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            const response = await axios.get(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
            );
            const address = response.data.address;
            const postcode = address.postcode || 'Postcode not found';
            setLocation(postcode);
            navigate(`/courts?postcode=${postcode}`);
          } catch (error) {
            console.error('Error getting postcode:', error);
          }
        },
        (error) => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  };

  return (
    <div className="home-container">
      <div className="cta-container">
        <div className="text-container">
          <span>FIND FUTSAL COURTS IN&nbsp;</span><FlagText></FlagText>
        </div>
        <div className="location-input-container">
          {/* <input
            type="text"
            id="postcode"
            className="location-input"
            placeholder="Enter your postcode"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          /> */}
           <div className="country-input-left">
          <label htmlFor="country"></label>
          <CountryInputHome
                 />        </div>
          <button className="location-button" onClick={handleLocationClick}>
            <img src={locationImage} alt="Location" />
          </button>
        </div>
        <button
          className={`cta-button ${isSpinning ? 'spinning' : ''}`}
          onClick={handleClick}
          disabled={isSpinning}
        >
          {isSpinning ? '⚽' : 'FIND A COURT'}
        </button>
      </div>

      {latestPost && showPopup && (
        <div className="blog-popup">
          <button className="close-btn" onClick={() => setShowPopup(false)}>✖</button>
          <p className="popup-text">OUR LATEST BLOG POST:</p>
          <h3 className="popup-title">{latestPost.title}</h3>
          <button
            className="popup-read-button"
            onClick={() => navigate(`/blog/${latestPost.slug}`)}
          >
            READ NOW
          </button>
        </div>
      )}
    </div>
  );
}

export default Home;
